import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Alert, Button, Col, Form, Row } from 'react-bootstrap';
import { uid } from 'uid';
import { CZContenedor } from '../CZ/CZContenedor';
import { EstadoContenedor } from '../Estado/EstadoContenedor';
import { Footer } from './Footer';
import { useInit } from '../../hooks/useInit';
import { useTablero } from '../../hooks/useTablero';

import { Resumen } from '../Resumen/Resumen';

import './Tablero.css'
import 'animate.css'
import { Descarga } from './Descarga';

export const Tablero = () => {

    const {hayJornada, titulos, procesos} = useInit();

    const [proceso, setProceso] = useState(
        axios.get(`${process.env.REACT_APP_PROD}/api/Procesos/max`)
        .then((res) => {
            return res.data[0].id
    }));

    useEffect(() => {
    axios.get(`${process.env.REACT_APP_PROD}/api/Procesos/max`)
        .then((res) => {
            setProceso(res.data[0].id);
        })
    }, [])


    const [prog, setProg] = useState("PR");
    const [nivel, setNivel] = useState(0);
    const [estado, setEstado] = useState(0);

    const {loading, info} = useTablero(prog, proceso, nivel, estado);

    const [resumenes, estados, czs] = [info[0], info[1], info[2]];
    
    const [deck, setDeck] = useState(true);

    const scroll = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }

    const cambiarProceso = (e) => {
        setProceso(e.target.value);
    }
    
    const cambiarNivel = (e) => {
        setNivel(e.target.value);
    }
    
    const cambiarPrograma = (e) => {
        setNivel(0);
        setEstado(0);
        setProg(e.target.value);
    }
    
    const cambiarEstado = (icveie) => {
        setEstado(icveie);
        scroll();
    }

    const resetEstado = () => {
        setEstado(0);
        scroll();
    }

    const cambiarVista = () => {
        setDeck(!deck);
    }

    return (
        <div>
            {
                hayJornada?
                (
                    <div className="banner animate__animated animate__fadeIn">
                        <div >
                                <p className="titulo-mid">SECRETARIA DE EDUCACIÓN PÚBLICA</p>
                                <p className="titulo-grd">INSTITUTO NACIONAL PARA LA EDUCACIÓN DE LOS ADULTOS</p>
                            {
                                titulos.map(({mainTitle, duration}) => {
                                    return <div key={uid()}>
                                        <p className="titulo-mid">{mainTitle}</p>
                                        <p className="titulo-mid">{duration}</p>
                                    </div>
                                })
                            }
                            <br />
                            <Row >
                                <Col md={3} className={"pb-2"}>
                                    <Form.Control as="select"   onChange={cambiarPrograma} value={prog}>
                                        <option value="PR">Programa Regular</option>
                                    </Form.Control>
                                </Col>
                                <Col md={3} className={"pb-2"}>
                                    <Form.Control as="select"  onChange={cambiarProceso} value={proceso}>
                                    {
                                        procesos.map((proceso) => {
                                            return <option key={proceso.id} value={proceso.id}> {proceso.fecha} </option>
                                        })
                                    }
                                    </Form.Control>
                                </Col>
                                <Col md={3} className={"pb-2"}>
                                    <Form.Control as="select"  onChange={cambiarNivel} value={nivel}>
                                        <option value="0">Todos los niveles</option>
                                        {
                                            prog === "PR" &&
                                            (
                                                <option value="1">Inicial</option>
                                            )
                                        }
                                        <option value="2">Intermedio</option>
                                        <option value="3">Avanzado</option>
                                    </Form.Control>
                                </Col>
                                <Col md={3}>
                                    <Descarga programa={prog} proceso={proceso} />
                                </Col>
                            </Row>
                        </div>
                        <br />
                        {
                            loading?
                            (
                                <Alert variant='info' style={{margin: "1rem"}}  >Cargando...</Alert>
                            ) :
                            (
                                <div>
                                    {
                                        estado === 0?
                                        (
                                            <p className="titulo-grd">NACIONAL</p>
                                        ) :
                                        (
                                            <p className="titulo-grd">{czs[0].cdesie}</p>
                                        )
                                    }
                                    {
                                        <Resumen resumenes={resumenes} />
                                    }

                                    <Button variant="secondary" onClick={cambiarVista}>Cambiar vista</Button>

                                    {
                                        estado === 0?
                                        (
                                            <EstadoContenedor estados={estados} deck={deck} prog={prog} cambiarEstado={cambiarEstado} />
                                        ) :
                                        (
                                            <CZContenedor czs={czs} deck={deck} prog={prog} resetEstado={resetEstado} />
                                        )
                                    }
                                </div>
                                
                                
                            )
                        }

                    </div>

                ) :
                (
                    <Alert variant='primary' style={{margin: "1rem"}}>
                        Cargando... Si el proceso toma tiempo, probablemente no haya una jornada en curso. Consulte con el personal jerárquico la fecha de la próxima jornada.
                    </Alert>
                )
            }

            <Footer />

        </div>
    )
}
